export const PRODUCT_MENTIONED = 'PRODUCT_MENTIONED';
export const RECENT_ORDER = 'RECENT_ORDER';
export const GLOBAL_FALLBACK = 'GLOBAL_FALLBACK';
